//import './App.css';
import {
  initiateSessionDeviceEAuth,
  syncLogicalClockESessions,
} from "@syserrepar/e-sessions-sdk";
import CssBaseline from "@mui/material/CssBaseline";
import { Fragment, lazy, Suspense, useEffect } from "react";
import RoutesApp from "./routes/Routes";
import EmailListProvider from "./providers/EmailListProvider";
import VerifyCookieUser from "./components/VerifyCookie";
//import AutoCredentialsProvider from "./providers/AutoCredentialsProvider";
import LogOut from "./components/LogOut";
import config from "./config/config";
import { verifyCookie } from "./utils/setCookie";
import RegisterProvider from "./providers/RegisterProvider";
const AutoCredentialsProvider = lazy(() =>
  import("./providers/AutoCredentialsProvider")
);

function App() {
  useEffect(() => {
    const run = async () => {
      console.log("Inicia APP");
      const userAgent = window.navigator.userAgent;
      const isSafari = /^((?!Chrome|Android).)*Safari/.test(userAgent);
      const safariVersion = /Version\/(\d+\.\d+)/.exec(userAgent);

      if (isSafari && safariVersion) {
        const version = parseFloat(safariVersion[1]);
        if (version === 15) {
          alert("ACTUALIZAR VERSIÓN DE SAFARI!");
        }
      }
      console.log("Ingresa en useeffect App, antes de iniciar sesion");

      initiateSessionDeviceEAuth();
      syncLogicalClockESessions();

      if (window.parent[0]) {
        const tokenFromCookies = await verifyCookie();
        console.log("WindowParent:::::::", document.referrer);
        console.log("Este es el jwt3::::", tokenFromCookies);
        if (tokenFromCookies) {
          const jwt = JSON.parse(atob(tokenFromCookies.split(".")[1]));
          if (jwt?.applicationData) {
            console.log("Hay un jwt3");
            window.parent.postMessage(
              { token: tokenFromCookies },
              config.ANCESTOR_ORIGIN_ME
            );
            window.parent.postMessage(
              { token: tokenFromCookies },
              config.ANCESTOR_ORIGIN_ME_DECLARATIONS
            );
            window.parent.postMessage(
              { token: tokenFromCookies },
              config.ANCESTOR_ORIGIN_ME_MIGRATION
            );
            window.parent.postMessage(
              { token: tokenFromCookies },
              config.ANCESTOR_ORIGIN_ME_EVENTANILLA
            );
            window.parent.postMessage(
              { token: tokenFromCookies },
              config.ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA
            );
          }
        }
      }
      console.log("termina iniciar sesion");
    };

    run();
  }, []);

  return (
    <Fragment>
      <EmailListProvider>
        <LogOut>
          <VerifyCookieUser />
          <CssBaseline />
          <Suspense fallback={<div></div>}>
            <AutoCredentialsProvider>
              <RegisterProvider>
                <RoutesApp />
              </RegisterProvider>
            </AutoCredentialsProvider>
          </Suspense>
        </LogOut>
      </EmailListProvider>
    </Fragment>
  );
}

export default App;
